import React from 'react';
import '../styles/components/LoadingSpinner.scss';

const LoadingSpinner = () => <div className="loader" />;
export default LoadingSpinner;
